<template>
    <div
        v-if="impersonation && impersonation.active"
        class="fixed inset-x-0 top-0 z-[10000] flex items-center justify-center gap-x-4 bg-amber-500 px-4 py-2 text-sm font-semibold text-amber-950 shadow-md"
        dusk="impersonation-banner"
    >
        <span>
            Impersonating
            <span class="font-bold">{{ impersonation.name }}</span>
        </span>
        <!-- Plain cross-subdomain form POST: the stop route lives on the admin
             host but the shared session cookie + CSRF token make it valid. -->
        <form
            method="POST"
            :action="impersonation.stopUrl"
        >
            <input
                type="hidden"
                name="_token"
                :value="impersonation.csrf"
            />
            <button
                type="submit"
                class="rounded-md bg-amber-950 px-3 py-1 text-xs font-semibold text-amber-50 hover:bg-amber-900"
            >
                Stop impersonating
            </button>
        </form>
    </div>
</template>
<script setup>
import { computed } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";

const impersonation = computed(() => usePage().props.value.impersonation ?? null);
</script>
